<template>
    <v-list-item>
        <v-list-item-content>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <b    v-bind="attrs"
                             v-on="on">{{ column.short_title }}</b>
                </template>
                <b>{{ column.title }}</b>
            </v-tooltip>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: "DataRecordHeaderItemValue",

    props: {
        item: {
            type: Object,
            require: true,
        },

        column: {
            type: Object,
            require: true,
        },

        noLabel: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {

        }
    },

    computed: {
        formattedValue() {

        },

        showLabel() {
            return !this.noLabel;
        },
    },
}
</script>

<style scoped>

</style>
